import { render, staticRenderFns } from "./CurrencyAttributeValue.vue?vue&type=template&id=49dc5866"
import script from "./CurrencyAttributeValue.vue?vue&type=script&lang=ts"
export * from "./CurrencyAttributeValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports